/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import './index.less';
import arrow_next2 from '@/assets/2025/arrow_next2.png';

interface ITopicItemProps {
  id: string;
  className?: string;
}

const TopicItem: React.FunctionComponent<ITopicItemProps> = ({
  id,
  className,
  children,
}) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState, getParagraphState, courses, language } =
    useStore();

  const course = courses[p_course];
  const currentTopic = course.topics.find(
    (itm: { id: string }) => itm.id === p_topic
  );
  const paragraphState = getParagraphState(p_course, p_topic);
  const currParagraph = currentTopic.paragraphs.find(
    (itm: any) => itm.id === id
  );
  //初始化completedKeys
  const currentIdx = currentTopic.paragraphs.indexOf(currParagraph);
  const lastParagraph = currentTopic.paragraphs[currentIdx - 1];
  const currParagraphState = paragraphState.find((itm) => itm.id === id);
  const lastParagraphState = paragraphState[currentIdx - 1];
  let nextParagraph = currentTopic.paragraphs[currentIdx + 1];
  nextParagraph = nextParagraph
    ? nextParagraph
    : course.topics.find(
        (itm: { step: string }) => itm.step === currentTopic?.step + 1
      );
  const [displayMsg, setDisplayMsg] = React.useState(false);
  let msgTimeout = setTimeout(() => null);
  useEffect(() => {
    const animationComponentsKeys = currParagraph?.components || [];
    updateParagraphState(
      p_course,
      p_topic,
      id,
      currParagraphState ? currParagraphState.state : 'not-start',
      animationComponentsKeys
    );
  }, []);
  const preventToNext = () => {
    const component = currParagraphState?.components[0];
    component &&
      document.getElementById(component)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });

    console.log(component);
    clearTimeout(msgTimeout);
    msgTimeout = setTimeout(() => setDisplayMsg(false), 3000);
    setDisplayMsg(true);
  };
  return lastParagraph?.isRequired &&
    lastParagraphState?.state !== 'completed' ? null : (
    <div data-paragraph={id} className={className}>
      {children}
      {nextParagraph &&
      currParagraph?.isRequired &&
      currParagraphState?.state !== 'completed' ? (
        <div className="next-paragraph-bar" onClick={preventToNext}>
          <div className="next_text_box">
            <span>
              {nextParagraph?.title}
              <img className="img" src={arrow_next2} alt="" />
            </span>
          </div>
        </div>
      ) : null}
      <div
        className={`prevent-msg-container animation ${
          displayMsg ? 'fade-in' : ''
        }`}
      >
        <div className="prevent-msg">
          {language === 'tc' ? (
            <>請先查看{currParagraph?.title}再繼續喔</>
          ) : language === 'sc' ? (
            <>请先查看{currParagraph?.title}再继续喔</>
          ) : (
            <>Please check {currParagraph?.title} before proceed</>
          )}
        </div>
      </div>
    </div>
  );
};

TopicItem.defaultProps = {
  className: '',
};
export default TopicItem;
